import { Component } from '@angular/core';
import { LangChangeEvent, TranslateModule, TranslateService } from '@ngx-translate/core';
import { environment } from '../../../environments/environment';
import { PostService } from '../../services/post.service';
import { CommonModule, NgFor, NgIf } from '@angular/common';
import { SafeTextPipe } from '../../safe-text.pipe';
import { TruncatePipe } from '../../truncate.pipe';

@Component({
  selector: 'app-csr',
  standalone: true,
  imports: [TranslateModule, NgFor, NgIf, CommonModule, TruncatePipe, SafeTextPipe],
  templateUrl: './csr.component.html',
  styleUrl: './csr.component.css'
})
export class CsrComponent {

  baseApiUrl = environment.baseApiUrl;
  charityWorkPosts: any[] = [];
  socialActivityPosts: any[] = [];
  groupedPosts: any[][] = [];
  currentLang: string = '';
  isLoading = true;

  constructor(private postService: PostService, private translate: TranslateService) {}

  ngOnInit() {
    this.loadCharityWorkPosts();

    this.loadSocialActivityPosts();

    this.currentLang = this.translate.currentLang || this.translate.defaultLang;
      this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
        this.currentLang = event.lang;
    })
  }

  
  isKhmer(): boolean {
    return this.translate.currentLang === 'kh';
  }

  isEnglish(): boolean {
    return this.translate.currentLang === 'en';
  }


  loadSocialActivityPosts() {
   this.postService.getSocialActivityPosts().subscribe({
      next: (response) => {
        this.socialActivityPosts = response.data.posts;
        this.isLoading = false;
      },
      error: (err) => {
        console.error('Error loading Social Activity Posts:', err);
        this.isLoading = false;
      }
    });
  }

  loadCharityWorkPosts() {
   this.postService.getCharityWorkPosts().subscribe({
      next: (response) => {
        this.charityWorkPosts = response.data.posts;
        this.isLoading = false;
      },
      error: (err) => {
        console.error('Error loading Charity Work Posts:', err);
        this.isLoading = false;
      }
    });
  }

  groupPosts() {
    for (let i = 0; i < this.charityWorkPosts.length; i += 2) {
      this.groupedPosts.push(this.charityWorkPosts.slice(i, i + 2));
    }
  }
}
